export default __webpack_public_path__ + "static/media/Bot-In-Server-Room.7e1f91f5.jpg";